import type { ChangeTypePolicy, ChangeTypePolicyFlags } from '../../types/changes';

/** Alinhado ao backend `REGULAR_GO_LIVE_TYPE_CODES`. */
export const REGULAR_GO_LIVE_TYPE_CODES = new Set(['normal', 'normal_correcao', 'padrao']);

/** Padrão recomendado (cadastro): internas desligadas, externas ligadas. O gestor pode alterar. */
export const INTERNAL_SUBTASKS_DEFAULT_OFF_CODES = new Set(['emergencial', 'normal_correcao']);

/**
 * Legado (HMR/bundles antigos): nenhum tipo é mais bloqueado no código — só via cadastro.
 * Mantido exportado vazio para não quebrar referências residuais a este identificador.
 */
export const INTERNAL_SUBTASKS_FORBIDDEN_CODES: ReadonlySet<string> = new Set();

export function legacyTypePolicyFlags(code: string): ChangeTypePolicyFlags {
  const allowsInternal =
    (code === 'normal' || code === 'padrao' || code === 'emergencial_retroativa') &&
    !INTERNAL_SUBTASKS_DEFAULT_OFF_CODES.has(code);
  return {
    enable_internal_subtasks: allowsInternal,
    enable_external_subtasks: true,
  };
}

export function policyFlagsForType(
  code: string,
  policies: ChangeTypePolicy[] | Record<string, ChangeTypePolicy>,
): ChangeTypePolicyFlags {
  const row = Array.isArray(policies)
    ? policies.find((item) => item.code === code)
    : policies[code];
  const base = row
    ? {
        enable_internal_subtasks: row.enable_internal_subtasks,
        enable_external_subtasks: row.enable_external_subtasks,
      }
    : legacyTypePolicyFlags(code);
  return base;
}

export function activeTypeOptions(
  policies: ChangeTypePolicy[],
): Array<{ value: string; label: string }> {
  if (!policies.length) return [];
  return policies
    .filter((item) => item.is_active !== false)
    .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0) || a.name.localeCompare(b.name, 'pt-BR'))
    .map((item) => ({ value: item.code, label: item.name }));
}

export function requiresRegularGoLiveWindow(code: string): boolean {
  return REGULAR_GO_LIVE_TYPE_CODES.has(code);
}
